<template>
  <v-container fluid>
      <v-layout justify-center>
          <v-flex md10>
            <DataTableMain :datatable="table" :on-success="successAction" :itemsAction="tableAction"/>
          </v-flex>
      </v-layout>
      <RolesDialog
        :model="user"
        v-if="get_dialogMain.dialog && (get_dialogMain.type == 'create' || get_dialogMain.type == 'update')" />
  </v-container>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import DataTableMain from '@/components/tables/DataTableMainLocal'
import RolesDialog from '@/components/dialog/catalogo/RolesDialog'
import router from '@/router'

export default {
  data: () => ({
    table: {
      header: {
        options: [
          { title: 'Refrescar', icon: 'mdi-cached', color: 'primary', action: 'refreshData', code: 'libre', hidden: '' },
          { title: 'Nuevo', icon: 'mdi-plus', color: 'success', action: 'newData', code: 'libre', hidden: '' }
        ],
        titles: [
          { text: 'Clave', value: 'slug', class: 'black--text' },
          { text: 'Nombre', value: 'nombre', class: 'black--text' },
          { text: 'Activo', value: 'Activo', class: 'black--text' },
          { text: 'Acceso Especial', value: 'descripcion.special', class: 'black--text' },
          // { text: 'Fecha Creacion', value: 'Created', class: 'black--text' },
          // { text: 'Fecha Actualizada', value: 'Updated', class: 'black--text' },
          { text: '', value: 'Actions', class: 'black--text' }
        ],
        loading: false
      },
      body: {
        data: [],
        actions: [
          { title: 'asignar Permisos', icon: 'mdi-border-color', color: 'lime lighten-1', action: 'permissionsAssign', code: 'libre', hidden: '' }
        ]
      },
      footer: {
        paging: true
      }
    },
    user: {}
  }),
  components: {
    DataTableMain,
    RolesDialog
  },
  mounted () {
    this.getUrl('empresa.roles-list')
  },
  methods: {
    successAction (item) {
      this[item.action](item)
    },
    refreshData (item) {
      this.table.header.loading = true
      this.getUrl('empresa.roles-list')
    },
    newData (item) {
      this.SHOW_DIALOG_MAIN({ type: 'create', with: 500, title: 'Nuevo Rol' })
    },
    tableAction (item) {
      this[item.action](item)
    },
    permissionsAssign (item) {
      router.push({ name: 'ViewPermissionsRoleAssign', params: { id: item.item.id } })
    },
    ...mapActions(['getUrlServices', 'postServiceListAction']),
    getUrl (objet) {
      if (this.get_urls != null) {
        const router = this.get_urls[objet]
        this.postServiceListAction({ url: router, data: {} })
      } else {
        this.getUrlServices()
      }
    },
    ...mapMutations(['SHOW_DIALOG_MAIN', 'CLEAR_OBJECTS'])
  },
  computed: {
    ...mapGetters(['get_dialogMain', 'get_urls', 'get_objects'])
  },
  watch: {
    get_urls () {
      this.getUrl('empresa.roles-list')
    },
    get_objects (vals) {
      if (vals) {
        this.table.header.loading = false
        this.table.body.data = vals
      }
    }
  },
  beforeDestroy () {
    this.CLEAR_OBJECTS()
  }

}
</script>

<style>

</style>
